import { gql } from 'apollo-angular';
import { workspaceRoleFragment } from './workspace-role.fragments';

export const WorkspaceRoleQuery = gql`
  query WorkspaceRoleQuery($id: ID!) {
    node(id: $id) {
      ... on WorkspaceRole {
        ...WorkspaceRoleFragment
      }
    }
  }
  ${workspaceRoleFragment}
`;
